import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '@/lib/axios'
import { KpiWidget } from './KpiWidget'

export function KpiPrenotazioniCambioWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<number>({
    queryKey: ['dashboard', 'prenotazioni-cambio-count'],
    queryFn: async () => {
      const res = await axiosInstance.get('/tire-service/prenotazioni/prossime/count', {
        params: { giorni: 7 },
      })
      return res.data?.count ?? 0
    },
    staleTime: 60000,
  })
  return (
    <KpiWidget
      title="Pren. cambio gomme (7gg)"
      value={data}
      loading={isLoading}
      color="#13c2c2"
      onClick={() => navigate('/tire-service')}
    />
  )
}
